import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {Marker} from "react-google-maps";
import {appContainer, Subscribe} from "../../contexts/app";
import TrialExpireModal from "../../components/TrialExpireModal";
import {UserAccountContext} from "../../contexts/userAccount";
import {TrainingContext} from "../../contexts/training";
import PageContainer from "../../components/PageContainer";
import PanelMapOverlay from "./PanelMapOverlay";
import FacilityPanel from "./FacilityPanel";
import BuildingPanel from "./BuildingPanel";
import MapFloor from "./MapFloor";
import FloorPanel from "./FloorPanel";
import {getPlaceInfo} from "../../components/Utilities";
import noty from "../../lib/noty";
import "./style.scss";

class IndexMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trialWarningOpen: this.props.trialWarningOpen,
      goToAcctSettings: false
    };
  }

  async componentDidMount() {
    const {facility, isNewSignUp} = this.props;
    if (isNewSignUp) {
      this.props.onToggleTrainingModal();
    }
    await facility.load();
  }

  render() {
    const {match, facility, buildings} = this.props;
    const {buildingId} = match.params;

    if (this.state.goToAcctSettings) {
      return <Redirect to="/account/settings" />;
    }
    return (
      <PageContainer {...this.props} editMode={false}>
        {this.renderTrialWarning()}
        <Switch>
          <Route
            exact
            path="/map/:facilityId"
            render={routeProps => this.renderPanelMapOverlay(routeProps, <FacilityPanel facility={facility} />)}
          />
          <Route
            exact
            path="/map/:facilityId/buildings/:buildingId"
            render={routeProps =>
              this.renderPanelMapOverlay(
                routeProps,
                <BuildingPanel building={buildings.get(buildingId)} />,
                this.renderMapBuilding()
              )
            }
          />
          <Route
            exact
            path="/map/:facilityId/buildings/:buildingId/floors/:floorId"
            render={routeProps =>
              this.renderPanelMapOverlay(routeProps, this.renderFloorPanel(routeProps), this.renderMapFloor(routeProps))
            }
          />
        </Switch>
      </PageContainer>
    );
  }

  renderTrialWarning() {
    const {subscriptionStatus} = this.props;

    if (subscriptionStatus.trialWarning && this.state.trialWarningOpen) {
      let {trialDaysRemaining, trialExpiration} = subscriptionStatus;

      return (
        <TrialExpireModal
          ownerName={this.props.ownerName}
          trialDaysRemaining={trialDaysRemaining}
          trialExpiration={trialExpiration}
          accountEditPermission={this.getAccountEditPermission()}
          onRequestClose={() => this.handleCloseTrialModal()}
          onAccountClick={() => this.handleGoToAccountSettings()}
        />
      );
    }
  }

  renderPanelMapOverlay(routeProps, panel, mapOverlay) {
    return (
      <PanelMapOverlay
        center={this.getCenter()}
        floor={this.props.floors.get(routeProps.match.params.floorId)}
        panel={panel}
        mapOverlay={mapOverlay}
      />
    );
  }

  renderMapBuilding() {
    const {buildings, match} = this.props;
    const building = buildings.get(match.params.buildingId);
    return (
      <Marker
        position={{
          lat: building.geo.coordinates[1],
          lng: building.geo.coordinates[0]
        }}
      />
    );
  }

  renderFloorPanel(routeProps) {
    return <FloorPanel floor={this.props.floors.get(routeProps.match.params.floorId)} />;
  }

  renderMapFloor(routeProps) {
    const floor = this.props.floors.get(routeProps.match.params.floorId);
    return <MapFloor floor={floor} />;
  }

  getCenter() {
    const {match, facility, buildings} = this.props;
    const {buildingId} = match.params;
    const facilityCenter = facility.geo.coordinates;
    return buildingId ? buildings.get(buildingId).geo.coordinates : facilityCenter;
  }

  getAccountEditPermission() {
    const {currentUser, permissions} = this.props;
    return permissions.toList().filter(permission => {
      return permission.user_id === currentUser.get("_id") && permission.permissions.edit.account;
    });
  }

  handleCloseTrialModal() {
    this.setState({trialWarningOpen: false});
    appContainer.set("trialWarningOpen", false);
  }

  handleGoToAccountSettings() {
    appContainer.set("trialWarningOpen", false);
    this.setState({trialWarningOpen: false, goToAcctSettings: true});
  }
}

export default routeProps => {
  return (
    <UserAccountContext.Consumer>
      {({subscriptionStatus}) => {
        return (
          <TrainingContext.Consumer>
            {({onToggleTrainingModal}) => {
              return (
                <Subscribe
                  to={[appContainer]}
                  render={app => {
                    const isNewSignUp = routeProps.location.search === "?signup=true";
                    const {facilityId} = routeProps.match.params;
                    const placeInfo = getPlaceInfo(app, routeProps.match.params);
                    if (!facilityId) {
                      // /map is the index page, just redirect
                      const firstFacility = placeInfo.facilities.first();
                      if (firstFacility) {
                        return <Redirect to={`/map/${firstFacility._id}`} />;
                      } else {
                        noty.errors(
                          "It appears you do not have access to any facilities. Contact your administrator to be given access."
                        );
                        return <Redirect to="/account" />;
                      }
                    }
                    return (
                      <IndexMap
                        {...routeProps}
                        {...placeInfo}
                        isNewSignUp={isNewSignUp}
                        currentUser={app.state.get("currentUser")}
                        trialWarningOpen={app.state.get("trialWarningOpen")}
                        ownerName={app.state.get("ownerName")}
                        permissions={app.state.get("permissions")}
                        subscriptionStatus={subscriptionStatus}
                        onToggleTrainingModal={onToggleTrainingModal}
                      />
                    );
                  }}
                />
              );
            }}
          </TrainingContext.Consumer>
        );
      }}
    </UserAccountContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Map/index.jsx